import { Component,ViewChild,TemplateRef, inject, OnDestroy } from '@angular/core';
import { ProfileModalComponent } from '../profile-modal/profile-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/services/loader.service';
import { Subscription, catchError } from 'rxjs';
import { Login } from 'src/app/models/login';
import { RegistrationDoneModalComponent } from '../registration-done-modal/registration-done-modal.component';

@Component({
  selector: 'app-asking-details',
  templateUrl: './asking-details-modal.component.html',
  styleUrls: ['./asking-details-modal.component.scss']
})
export class AskingDetailsModalComponent implements OnDestroy{
 // #region INPUT, OUTPUT, VIEWCHILD
 @ViewChild('askingDetailsModal') askingDetailsTemplate!: TemplateRef<AskingDetailsModalComponent>;
 @ViewChild('profileModal') profileComponent!: ProfileModalComponent;
 @ViewChild('registrationDoneModal')
 registrationDoneComponent!: RegistrationDoneModalComponent;
// #endregion

private modalService = inject(NgbModal);
private subscription: Subscription;
user:User = new User();
loginDetails : Login = new Login();

constructor(
  private userService: UserService,
  private toastr: ToastrService,
  private loaderService: LoaderService,
) {
  this.user = this.userService.getUser();
  this.userService.userData$.subscribe((userData) => {
    this.user = userData;
  });
}

openModal(modal: TemplateRef<any>, windowClass: string = '') {
  this.modalService.open(modal, {
    windowClass: `project-modal ${windowClass}`,
    centered: true,
    backdropClass: 'primary-backdrop',
  });
}

notNowClicked(){
  this.loaderService.setLoading(true);
  this.subscription = this.userService.create('/api/tenants/membershipApp/CreateMembershipUser', this.user).pipe(
    catchError((error) => {
      this.loaderService.setLoading(false);
      throw error;
    })
  )
  .subscribe((response) => {
    this.toastr.success('User created successfully!');
    this.openModal(
      this.registrationDoneComponent.registrationDoneTemplate,
      'registration-done-modal'
    );
    this.userService.completeRegistration(this.user);
    this.loaderService.setLoading(false);
  });
}

ngOnDestroy() {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}
}
